const ROOT_ELEMENT_ID = 'genesys-widget-root';

const rootElement = document.getElementById(ROOT_ELEMENT_ID);

const init = async (): Promise<void> => {
  const appRender = await import('./AppRender');

  if (!rootElement) {
    throw new Error(`Element #${ROOT_ELEMENT_ID} was not found!`);
  }

  appRender.render(rootElement);
};

init().catch((error) => {
  throw error;
});

